import { database } from "../../firebaseConfig";
import { ref, update } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytesResumable, deleteObject } from "firebase/storage";

// ----------------------
// Helpers immagini
// ----------------------
export async function uploadImage(file, folder) {
  const storage = getStorage();
  const ext = file.name.split(".").pop().toLowerCase();
  const filename = `${Date.now()}.${ext}`;
  const pathOnStorage = `${folder}/${filename}`;
  const sRef = storageRef(storage, pathOnStorage);

  const uploadTask = uploadBytesResumable(sRef, file, {
    contentType: file.type,
  });

  await new Promise((resolve, reject) => {
    uploadTask.on("state_changed", null, reject, resolve);
  });

  return pathOnStorage;
}

export async function deleteImage(path) {
  const storage = getStorage();
  try {
    await deleteObject(storageRef(storage, path));
    console.log("Immagine eliminata:", path);
  } catch (err) {
    console.warn("Impossibile eliminare immagine:", err);
  }
}

// ----------------------
// CRUD Info del Giorno
// ----------------------
export async function saveInfo(draft) {
  await update(ref(database, "/"), {
    infoDelGiorno: draft.infoDelGiorno || ""
  });
}

// ----------------------
// CRUD Sezioni
// ----------------------
export async function saveSection(section, draft, selectedImageFile, getSectionIndexById) {
  const sIdx = getSectionIndexById(section.id);
  const path = `/sezioni/${sIdx}`;

  let immaginePath = section.immaginePath;

  if (selectedImageFile) {
    immaginePath = await uploadImage(selectedImageFile, "immagini/sezioni");
    if (section.immaginePath && section.immaginePath !== immaginePath) {
      await deleteImage(section.immaginePath);
    }
  }

  const payload = {
    titolo: draft.titolo.trim(),
    slug: draft.slug.trim(),
    descrizione: draft.descrizione.trim(),
    ...(immaginePath ? { immaginePath } : {})
  };

  await update(ref(database, path), payload);
}

export async function createSection(draft, selectedImageFile, sezioni) {
  const newId = Date.now();
  let immaginePath = "";

  if (selectedImageFile) {
    immaginePath = await uploadImage(selectedImageFile, "immagini/sezioni");
  }

  const newSection = {
    id: newId,
    titolo: draft.titolo.trim(),
    slug: draft.slug.trim(),
    descrizione: draft.descrizione.trim(),
    articoli: [],
    ...(immaginePath ? { immaginePath } : {})
  };

  const updatedSezioni = [...(sezioni || []), newSection];
  await update(ref(database, "/"), { sezioni: updatedSezioni });
}

// ----------------------
// CRUD Articoli
// ----------------------
export async function saveArticle(section, article, draft, selectedArticleImageFile, getSectionIndexById, getArticleIndexById) {
  const sIdx = getSectionIndexById(section.id);
  const aIdx = getArticleIndexById(section, article.id);
  const path = `/sezioni/${sIdx}/articoli/${aIdx}`;

  let immaginePath = article.immaginePath;

  if (selectedArticleImageFile) {
    immaginePath = await uploadImage(selectedArticleImageFile, "immagini/articoli");
    if (article.immaginePath && article.immaginePath !== immaginePath) {
      await deleteImage(article.immaginePath);
    }
  }

  const payload = {
    titolo: draft.titolo.trim(),
    slug: draft.slug.trim(),
    curiosita: draft.curiositaText
      .split("\n")
      .map(s => s.trim())
      .filter(Boolean),
    ...(immaginePath ? { immaginePath } : {})
  };

  await update(ref(database, path), payload);
}

export async function createArticle(section, draft, selectedArticleImageFile, getSectionIndexById) {
  const sIdx = getSectionIndexById(section.id);
  let immaginePath = "";

  if (selectedArticleImageFile) {
    immaginePath = await uploadImage(selectedArticleImageFile, "immagini/articoli");
  }

  const newArticle = {
    id: Date.now(),
    titolo: draft.titolo.trim(),
    slug: draft.slug.trim(),
    curiosita: draft.curiositaText
      .split("\n")
      .map(s => s.trim())
      .filter(Boolean),
    ...(immaginePath ? { immaginePath } : {})
  };

  const updatedArticoli = [...(section.articoli || []), newArticle];
  await update(ref(database, `/sezioni/${sIdx}`), { articoli: updatedArticoli });
}
